import { createTheme } from '@mui/material/styles';

const sharedTypography = {
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
    ].join(','),
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    body1: { fontSize: '1rem' },
    body2: { fontSize: '0.875rem' },
    button: {
        textTransform: 'none',
        fontWeight: 600,
    },
};

const sharedShape = { borderRadius: 8 };

const sharedComponents = {
    MuiAppBar: {
        defaultProps: { elevation: 0 },
    },
    MuiCard: {
        defaultProps: { elevation: 1 },
        styleOverrides: {
            root: {
                transition: 'box-shadow 0.2s ease, transform 0.2s ease',
                '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                    transform: 'translateY(-2px)',
                },
            },
        },
    },
    MuiButton: {
        defaultProps: { disableElevation: true },
    },
    MuiChip: {
        styleOverrides: {
            root: { fontWeight: 500 },
        },
    },
};

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#B61219',
            light: '#B61219',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#f5c76b',
            light: '#f8d99b',
            dark: '#fbebcb',
            contrastText: '#B61219',
        },
        background: {
            default: '#fafaf8',
            paper: '#ffffff',
        },
        text: {
            primary: '#1a1a1a',
            secondary: '#5a5a5a',
        },
        divider: 'rgba(0,0,0,0.10)',
    },
    typography: sharedTypography,
    shape: sharedShape,
    components: {
        ...sharedComponents,
        MuiAppBar: {
            ...sharedComponents.MuiAppBar,
            styleOverrides: {
                root: { borderBottom: '1px solid rgba(0,0,0,0.08)' },
            },
        },
        MuiButton: {
            ...sharedComponents.MuiButton,
            styleOverrides: {
                containedPrimary: {
                    '&:hover': { backgroundColor: '#5C0001' },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: { borderColor: 'rgba(0,0,0,0.10)' },
            },
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#e57373',
            light: '#ef9a9a',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#f5c76b',
            light: '#f8d99b',
            dark: '#c49a3a',
            contrastText: '#1a1a1a',
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
        text: {
            primary: '#e8e8e8',
            secondary: '#a0a0a0',
        },
        divider: 'rgba(255,255,255,0.10)',
    },
    typography: sharedTypography,
    shape: sharedShape,
    components: {
        ...sharedComponents,
        MuiAppBar: {
            ...sharedComponents.MuiAppBar,
            styleOverrides: {
                root: {
                    borderBottom: '1px solid rgba(255,255,255,0.08)',
                    backgroundColor: '#B61219',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: { borderColor: 'rgba(255,255,255,0.10)' },
            },
        },
    },
});

export default lightTheme;
